import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
import FormLabel from './FormLabel';
const VARIANTS = {
  spacing: 'mb-6',
  no_spacing: ''
} as const satisfies Record<string, string>;
type FormGroupHorizontalProps = Pick<React.ComponentProps<typeof FormLabel>, 'required'> & {
  label: React.ReactNode;
  labelSize?: React.ComponentProps<typeof FormLabel>['size'];
  /** Content rendered inside a `p` tag */
  description?: React.ReactNode;
  htmlFor?: string;
  variant?: keyof typeof VARIANTS;
  className?: string;
  children: ReactNode;
};
export default function FormGroupHorizontal(t0) {
  const $ = _c(21);
  const {
    label,
    labelSize,
    description,
    htmlFor,
    variant: t1,
    className,
    children,
    required
  } = t0;
  const variant = t1 === undefined ? "spacing" : t1;
  const t2 = VARIANTS[variant];
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cx("w-full", [t2, className]);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== htmlFor || $[4] !== label || $[5] !== labelSize || $[6] !== required) {
    t4 = label && <FormLabel htmlFor={htmlFor} size={labelSize} required={required}>{label}</FormLabel>;
    $[3] = htmlFor;
    $[4] = label;
    $[5] = labelSize;
    $[6] = required;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== description) {
    t5 = description && <p className="text-sm text-blue-500">{description}</p>;
    $[8] = description;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex min-w-0 flex-col gap-1">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children) {
    t7 = <div className="mt-1 min-w-0 md:mt-0">{children}</div>;
    $[13] = children;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-x-5 gap-y-3 md:flex-row md:items-start md:justify-between">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t8) {
    t9 = <div data-form-field="" className={t3}>{t8}</div>;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}